(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5707],{

/***/ 44477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/container/index.tsx
var container = __webpack_require__(14094);
// EXTERNAL MODULE: ./components/common/text/index.tsx
var common_text = __webpack_require__(96861);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./components/footer/styles.ts


var FooterWrapper = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  displayName: "styles__FooterWrapper",
  componentId: "sc-1uph4p-0"
})([""]);
var FooterTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FooterTopWrapper",
  componentId: "sc-1uph4p-1"
})(["margin-bottom:80px;display:flex;justify-content:center;> div{display:grid;grid-template-areas:'f1 f2' 'f3 f2';column-gap:110px;}.footer{&-logo{grid-area:f1;display:flex;}&-nav{grid-area:f2;display:grid;grid-template-columns:repeat(4,1fr);grid-template-rows:repeat(1,1fr);gap:80px;&-col{> p{color:", ";margin-bottom:20px;}> div{display:flex;flex-direction:column;gap:16px;> a{display:flex;&:hover{text-decoration:underline;}> p{color:", ";}}}}}&-alt{grid-area:f3;max-width:220px;margin-top:64px;> p{color:", ";}}}@media ", "{margin-bottom:0;> div{grid-template-areas:'f1' 'f2' 'f3';padding:60px 40px;}.footer{&-logo{margin-bottom:52px;}&-nav{gap:24px;}&-alt{max-width:unset;}}}@media ", "{> div{padding:80px 20px;}.footer{&-logo{margin-bottom:40px;}&-nav{column-gap:20px;row-gap:28px;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);&-col{> div{gap:12px;}}}&-alt{max-width:unset;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayPallet10;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.bluePallet1;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grayPallet10;
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet);
var FooterBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FooterBottom",
  componentId: "sc-1uph4p-2"
})(["background-color:", ";padding-top:100px;padding-bottom:80px;display:flex;justify-content:center;.top{padding-bottom:45px;border-bottom:2px solid #637d95;> p{color:", ";&:last-child{margin-top:20px;}}}.bottom{margin-top:30px;> p{color:", ";}}@media ", "{padding-top:60px;padding-bottom:60px;.top{padding-bottom:20px;}.bottom{margin-top:20px;}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bluePallet1;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.bluePallet7;
}, breakpoints/* device.laptop */.U.laptop);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
// EXTERNAL MODULE: ./constants/links.ts
var links = __webpack_require__(97449);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/footer/FooterTop.tsx











function FooterTop(_ref) {
  var forIframe = _ref.forIframe;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterTopWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(container/* Container */.W, {
      size: "md",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "footer-logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: forIframe ? links/* HOME_PAGE_LINK */.$U : routes/* HOME_ROUTE */.ef,
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/static/logo-richr-new-colored.svg",
              width: 132,
              height: 44,
              priority: true,
              quality: 100
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "footer-nav",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-nav-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "About"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: links/* MANIFESTO_LINK */.ar,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Manifesto"
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-nav-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "Terms & Privacy"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: links/* TERMS_AND_PRIVACY_LINK */.SB,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Terms of Service"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: links/* PRIVACY_LINK */.xL,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Privacy Policy"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: routes/* ABA_ROUTE */.U3,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Affiliated Business Disclosure"
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-nav-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "Resources"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: links/* BLOG_LINK */.rI,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Blog"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: links/* FAQ_LINK */.Rh,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "FAQ"
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-nav-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "Resources"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://twitter.com/getrichrnow/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Twitter"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://www.pinterest.com.au/getrichrnow/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Pinterest"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://www.instagram.com/getrichrnow/",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Instagram"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://www.facebook.com/getrichrnow",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  children: "Facebook"
                })
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "footer-alt",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
          children: ["\xA9 Copyright ", new Date().getFullYear(), ". Richr Inc. ALL RIGHTS RESERVED."]
        })
      })]
    })
  });
}

/* harmony default export */ var footer_FooterTop = (/*#__PURE__*/(0,react.memo)(FooterTop));
;// CONCATENATED MODULE: ./components/footer/index.tsx








function Footer(_ref) {
  var forIframe = _ref.forIframe;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(footer_FooterTop, {
      forIframe: forIframe
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterBottom, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(container/* Container */.W, {
        size: "md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "top",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "The information provided regarding the business opportunity of Richr Homes reducing its broker fee from 3% to 1% if the Seller invests at least 2% of its sales proceeds into an investment account at Richr Money LLC is for informational purposes only and should not be considered legal, tax or financial advice. The decision to invest in any investment account should be made after consulting with your financial advisor, tax advisor and attorney. Richr Money LLC and Richr Homes are affiliated businesses and therefore have a vested interest in the success of both businesses and the reduction associated with this opportunity. We encourage potential investors to ask questions and seek counsel before making any investment decisions. All investments are risky and subject to loss. Additionally, the answers provided to the risk assessment questions may directly affect the products suggested by Richr Money LLC for investment. We encourage potential investors to take their time when answering these questions to ensure the best fit for their individual financial goals and risk tolerance. Additional information about Richr Money can be found in its Form ADV Parts 2A, 2B and 3 (CRS), available upon request."
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bottom",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            children: "All information provided is deemed reliable but is not guaranteed and should be independently verified. You should consult your own professionals for financial, legal, or tax advice and conduct your own due diligence. Brokerage services are provided by Richr MP Holdings LLC DBA Richr Homes, FL License # 1060165. Services of Richr affiliates, Richr Homes, Richr Money LLC, Richr Insurance LLC and Richr Title LLC, are optional."
          })
        })]
      })
    })]
  });
}

/* harmony default export */ var footer = (Footer);

/***/ }),

/***/ 22870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ main_layout; }
});

// EXTERNAL MODULE: ./components/footer/index.tsx + 2 modules
var footer = __webpack_require__(44477);
// EXTERNAL MODULE: ./components/header/index.tsx + 12 modules
var header = __webpack_require__(84621);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
;// CONCATENATED MODULE: ./components/layout/main-layout/styles.ts

var MainLayoutWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__MainLayoutWrapper",
  componentId: "sc-7cnbt6-0"
})(["display:flex;flex-direction:column;min-height:100vh;> main{flex:auto;}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/layout/main-layout/index.tsx






function MainLayout(_ref) {
  var children = _ref.children,
      transparentHeader = _ref.transparentHeader;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MainLayoutWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
      transparentHeader: transparentHeader
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.Z, {})]
  });
}

/* harmony default export */ var main_layout = (MainLayout);

/***/ }),

/***/ 16478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_aba; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./components/layout/main-layout/index.tsx + 1 modules
var main_layout = __webpack_require__(22870);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(54490);
;// CONCATENATED MODULE: ./containers/aba/messages.ts

var scope = 'app.components.aba';
/* harmony default export */ var messages = ((0,lib/* defineMessages */.vU)({
  title: {
    id: "".concat(scope, ".title"),
    defaultMessage: 'AFFILIATED BUSINESS DISCLOSURE - SELLER'
  },
  subTitleFrom: {
    id: "".concat(scope, ".subTitleFrom"),
    defaultMessage: 'From: Richr MP Holdings LLC DBA Richr Homes'
  },
  subTitleTo: {
    id: "".concat(scope, ".subTitleTo"),
    defaultMessage: 'To: The Undersigned Property Seller'
  },
  descriptionOne: {
    id: "".concat(scope, ".descriptionOne"),
    defaultMessage: 'This is to give you notice that Richr MP Holdings LLC DBA Richr Homes (which provides real estate brokerage services) has a business relationship with  Richr Title LLC (which provides title insurance policies, title examination and settlement services), Richr Ins. Holdings LLC DBA Richr Insurance (which provides homeowners insurance) and Richr Money LLC (which is an internet investment advisor). Richr MP Holdings LLC DBA Richr Homes has an affiliate relationship with Richr Title LLC, Richr Ins. Holdings LLC DBA Richr Insurance and Richr Money LLC..'
  },
  descriptionTwo: {
    id: "".concat(scope, ".descriptionTwo"),
    defaultMessage: 'Because of these relationships, referrals by any of these companies to one another may provide Richr MP Holdings LLC DBA Richr Homes, Richr Title  LLC, Richr Ins. Holdings LLC DBA Richr Insurance or Richr Money LLC, with a financial or other benefit. Set forth below is the estimated charge or range of charges for the settlement services listed.'
  },
  descriptionThree: {
    id: "".concat(scope, ".descriptionThree"),
    defaultMessage: 'You are NOT required to use  the listed provider(s) as a condition for the purchase, sale, or refinance of the subject property.  THERE ARE FREQUENTLY OTHER SETTLEMENT SERVICE PROVIDERS AVAILABLE WITH SIMILAR SERVICES. YOU  ARE FREE TO SHOP AROUND TO DETERMINE THAT YOU ARE RECEIVING THE BEST SERVICES AND THE BEST  RATE FOR THESE SERVICES.'
  },
  richrTitleLLC: {
    id: "".concat(scope, ".richrTitleLLC"),
    defaultMessage: 'RICHR TITLE LLC'
  },
  titleSearchFee: {
    id: "".concat(scope, ".titleSearchFee"),
    defaultMessage: 'Title Search Fee'
  },
  searchFeeValue: {
    id: "".concat(scope, ".searchFeeValue"),
    defaultMessage: '$125 - $250'
  },
  closing: {
    id: "".concat(scope, ".closing"),
    defaultMessage: 'Closing'
  },
  closingValue: {
    id: "".concat(scope, ".closingValue"),
    defaultMessage: '$0 - $499'
  },
  ownerPolicy: {
    id: "".concat(scope, ".ownerPolicy"),
    defaultMessage: 'Owner{rsquo}s Policy of Title Insurance Promulgated rate:'
  },
  ownerPolicyValue: {
    id: "".concat(scope, ".ownerPolicyValue"),
    defaultMessage: '$5.75 per $1000 up to $100,000; $5.00 per $1000 up to $1,000,000; $2.50 per $1000 over $1,000,000 up to $5,000,000 '
  },
  reIssue: {
    id: "".concat(scope, ".reIssue"),
    defaultMessage: 'Re-Issue Title Insurance Rate'
  },
  reIssueNotice: {
    id: "".concat(scope, ".reIssueNotice"),
    defaultMessage: '{nbsp}(subject to Re-issue requirements)'
  },
  reIssueValue: {
    id: "".concat(scope, ".reIssueValue"),
    defaultMessage: '$3.30 per $1000 up to $100,000; $3.00 per $1000 up to $1,000,000'
  },
  mortagePolicy: {
    id: "".concat(scope, ".mortagePolicy"),
    defaultMessage: 'Mortgage Policy '
  },
  mortagePolicyNotice: {
    id: "".concat(scope, ".mortagePolicyNotice"),
    defaultMessage: '(Simultaneous issue)'
  },
  mortagePolicyValue: {
    id: "".concat(scope, ".mortagePolicyValue"),
    defaultMessage: '$25 up to value of Owner{rsquo}s policy and any amount over that value will be charged at the Promulgated rate above'
  },
  standardEndorsements: {
    id: "".concat(scope, ".standardEndorsements"),
    defaultMessage: 'Standard Endorsements '
  },
  standardEndorsementsNotice: {
    id: "".concat(scope, ".standardEndorsementsNotice"),
    defaultMessage: '(each)'
  },
  standardEndorsementsValue: {
    id: "".concat(scope, ".standardEndorsementsValue"),
    defaultMessage: '$35.00 up to 10% of Combined Policy Premiums'
  },
  abaInsurance: {
    id: "".concat(scope, ".abaInsurance"),
    defaultMessage: 'RICHR INSURANCE - RESIDENTIAL POLICIES'
  },
  insuranceDescription: {
    id: "".concat(scope, ".insuranceDescription"),
    defaultMessage: 'Premiums are based on the insurance product and may depend on location of property & type of construction, its age, credit score and past  claims of the insured.'
  },
  bottomText: {
    id: "".concat(scope, ".bottomText"),
    defaultMessage: 'I have read this disclosure form and understand that Richr MP Holdings LLC DBA Richr Homes, Richr Title LLC and/or Richr Ins.  Holdings LLC dba Richr Insurance, is referring me to purchase the above-described service(s) and they may receive a financial or other benefit as the result of this referral. I represent that I am the owner or authorized representative of the owner(s) of the Property identified below.'
  },
  property: {
    id: "".concat(scope, ".property"),
    defaultMessage: 'Property:'
  },
  seller: {
    id: "".concat(scope, ".seller"),
    defaultMessage: 'Seller Name:'
  },
  sellerSign: {
    id: "".concat(scope, ".buyer"),
    defaultMessage: 'Seller Signature:'
  },
  date: {
    id: "".concat(scope, ".date"),
    defaultMessage: 'Date'
  }
}));
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./containers/aba/styles.ts


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-qb9eez-0"
})(["overflow-x:hidden;display:flex;justify-content:center;margin:200px auto 0px;flex-direction:column;color:", ";padding:0 20px 100px;max-width:96vw;@media ", "{max-width:1370px;}.main-aba-property{display:flex;padding-bottom:30px;.aba-line{width:100%;border-bottom:1px solid ", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayPallet16;
}, breakpoints/* device.largeLaptop */.U.largeLaptop, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grayPallet17;
});
var Header = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styles__Header",
  componentId: "sc-qb9eez-1"
})(["text-align:center;margin-bottom:50px;font-size:54px;color:", ";span{background-size:100% 100%;background-position:0 0;background-image:url('/static/images/line.png');}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackPallet2;
});
var Subtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Subtitle",
  componentId: "sc-qb9eez-2"
})(["font-weight:", ";padding-bottom:10px;line-height:1.25;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.fontWeights.bold;
});
var Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Text",
  componentId: "sc-qb9eez-3"
})(["line-height:1.25;span{font-weight:", ";}&.bottomText{padding:30px 0;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.fontWeights.bold;
});
var Table = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Table",
  componentId: "sc-qb9eez-4"
})(["display:flex;flex-direction:column;"]);
var TableRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__TableRow",
  componentId: "sc-qb9eez-5"
})(["border:2px solid ", ";border-bottom:none;display:flex;&:first-child{border:none;.rightCell{border:none;}}&:last-child,&.borderBottom{border-bottom:2px solid ", ";}.rightCell{color:", ";border-left:2px solid ", ";padding:8px 10px;width:60%;}.aba-table-col-title{font-weight:", ";padding:15px 20px 0px;color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.black;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.black;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greenPallet4;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.black;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.bluePallet10;
});
var TableCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__TableCol",
  componentId: "sc-qb9eez-6"
})(["font-weight:", ";width:40%;padding:8px 20px;color:", ";.notice{color:", ";font-weight:", ";}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.bluePallet10;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grayPallet16;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontWeights.regular;
});
var Insurance = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Insurance",
  componentId: "sc-qb9eez-7"
})([".aba-insurance-title{font-weight:", ";text-align:center;padding-top:30px;padding-bottom:10px;color:", ";}.aba-insurance-text{border:2px solid ", ";padding:8px 20px;}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.fontWeights.medium;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.bluePallet10;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.black;
});
var SellerBuyer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__SellerBuyer",
  componentId: "sc-qb9eez-8"
})(["display:flex;@media ", "{flex-direction:column;}.main-aba-seller-buyer-leftCol{width:50%;@media ", "{width:50%;}}.main-aba-seller-buyer-col{width:50%;display:flex;padding-top:20px;&-subcol{display:flex;}}.aba-line-person,.aba-line-date{border-bottom:1px solid ", ";}.aba-line-person{margin-right:5px;width:200px;@media ", "{width:160px;}}.aba-line-date{width:150px;@media ", "{width:80px;}}"], breakpoints/* device.smallLaptop */.U.smallLaptop, breakpoints/* device.smallLaptop */.U.smallLaptop, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.grayPallet17;
}, breakpoints/* device.smallLaptop */.U.smallLaptop, breakpoints/* device.smallLaptop */.U.smallLaptop);
/* harmony default export */ var styles = ({
  Wrapper: Wrapper,
  Header: Header,
  Subtitle: Subtitle,
  Text: Text,
  Table: Table,
  TableRow: TableRow,
  TableCol: TableCol,
  Insurance: Insurance,
  SellerBuyer: SellerBuyer
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/aba/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









function Aba() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(main_layout/* default */.Z, {
    transparentHeader: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.Header, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.title))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Subtitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.subTitleFrom))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Subtitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.subTitleTo))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Text, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.descriptionOne))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Text, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.descriptionTwo))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Subtitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.descriptionThree))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.Table, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.TableCol, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "aba-table-col-title",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.richrTitleLLC))
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.TableCol, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.titleSearchFee))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.searchFeeValue))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.TableCol, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.closing))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.closingValue))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles.TableCol, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread(_objectSpread({}, messages.ownerPolicy), {}, {
              values: {
                rsquo: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: "\u2019"
                })
              }
            }))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.ownerPolicyValue))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableCol, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.reIssue)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "notice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread(_objectSpread({}, messages.reIssueNotice), {}, {
                values: {
                  nbsp: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "\xA0"
                  })
                }
              }))
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.reIssueValue))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableCol, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.mortagePolicy)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "notice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.mortagePolicyNotice))
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread(_objectSpread({}, messages.mortagePolicyValue), {}, {
              values: {
                rsquo: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: "\u2019"
                })
              }
            }))
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles.TableCol, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.standardEndorsements)), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "notice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.standardEndorsementsNotice))
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "aba-table-col rightCell",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.standardEndorsementsValue))
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.Insurance, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "aba-insurance-title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.abaInsurance))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "aba-insurance-text",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.insuranceDescription))
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles.Text, {
        className: "bottomText",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.bottomText))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.Text, {
        className: "main-aba-property",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.property)), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "aba-line"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles.SellerBuyer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "main-aba-seller-buyer-leftCol",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "main-aba-seller-buyer-col",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "main-aba-seller-buyer-col-subcol",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.seller)), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "aba-line-person"
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "main-aba-seller-buyer-col",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "main-aba-seller-buyer-col-subcol",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.sellerSign)), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "aba-line-person"
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "main-aba-seller-buyer-rightCol",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "main-aba-seller-buyer-col",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "main-aba-seller-buyer-col-subcol",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, _objectSpread({}, messages.date)), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "aba-line-date"
              })]
            })
          })
        })]
      })]
    })
  });
}

/* harmony default export */ var aba = (Aba);
;// CONCATENATED MODULE: ./pages/aba/index.tsx



function ABAPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(aba, {});
}

/* harmony default export */ var pages_aba = (ABAPage);

/***/ }),

/***/ 11395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aba",
      function () {
        return __webpack_require__(16478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vU": function() { return /* binding */ defineMessages; }
});

// UNUSED EXPORTS: FormattedDate, FormattedDateParts, FormattedDateTimeRange, FormattedDisplayName, FormattedList, FormattedListParts, FormattedMessage, FormattedNumber, FormattedNumberParts, FormattedPlural, FormattedRelativeTime, FormattedTime, FormattedTimeParts, IntlContext, IntlProvider, InvalidConfigError, MessageFormatError, MissingDataError, MissingTranslationError, RawIntlProvider, ReactIntlError, ReactIntlErrorCode, UnsupportedFormatterError, createIntl, createIntlCache, defineMessage, injectIntl, useIntl

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var components_useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createFormattedComponent.js



var DisplayName;
(function (DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function (DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function (props) {
    var intl = (0,components_useIntl/* default */.Z)();
    var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
var FormattedListParts = function (props) {
    var intl = useIntl();
    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = 'FormattedNumberParts';
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props, ["value", "children"]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate'
            ? intl.formatDateToParts(date, formatProps)
            : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function (props) {
        var intl = (0,components_useIntl/* default */.Z)();
        var value = props.value, children = props.children, formatProps = (0,tslib_es6/* __rest */._T)(props
        // TODO: fix TS type definition for localeMatcher upstream
        , ["value", "children"]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
            return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

;// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.js










function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
var FormattedDate = createFormattedComponent('formatDate');
var FormattedTime = createFormattedComponent('formatTime');
var FormattedNumber = createFormattedComponent('formatNumber');
var FormattedList = createFormattedComponent('formatList');
var FormattedDisplayName = createFormattedComponent('formatDisplayName');
var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime');



/***/ }),

/***/ 44012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 86896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,8074,6400,4621,9774,2888,179], function() { return __webpack_exec__(11395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);